import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import React from "react";

const Confirm = React.memo(ConfirmBase);
function ConfirmBase({
                                    handleClose,
                                    title,
                                    open,
                                    message,
                                    messageButton,
                                    action,
                                    secondaryAction,
                                    secondaryActionButton
                                }) {
    return (<>
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>{title ?? "Confirm"}</DialogTitle>
            <DialogContent sx={{wordWrap: "break-word"}}>
                {message}
            </DialogContent>
            <DialogActions sx={{justifyContent: "space-between"}}>
                {secondaryActionButton &&
                    <Button onClick={() => {
                        secondaryAction();
                        handleClose();
                    }}>{secondaryActionButton}</Button>
                }
                <div style={{marginLeft: "auto"}}>
                    <Button onClick={() => {
                        action();
                        handleClose();
                    }}>{messageButton}</Button>
                    <Button onClick={handleClose}>Cancel</Button>
                </div>
            </DialogActions>
        </Dialog>
    </>);
}

export default Confirm;